<template>
    <v-checkbox
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        label="Locație vizibilă pe ofertă"
        density="compact"
        color="secondary"
        hide-details
    />
</template>

<script>
export default {
    name: "OfferLocationVisibleOnPdfCheckbox",
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:modelValue"],
};
</script>
